import React from 'react';
import { Panel, Label } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import LabelWithTooltip from '../../common/components/LabelWithTooltip';
import ui from '../../common/services/ui';
import { withTranslation } from 'react-i18next';
import { mapStatusToLabel, paymentDetailsLink as detailsLink } from '../paymentHistory/utils';

const List = ({ isReadonly, t, parentId, ...rest }) => {

	const columns = [
		{
			header: t('PaymentHistory_Id'),
			accessor: 'paymentHistoryId',
			sortable: true,
			cell: (paymentHistoryId, row) => <Link to={detailsLink(row.category.id, paymentHistoryId)}>{paymentHistoryId}</Link>
		},
		{
			header: t('InstalmentPayment_Id'),
			accessor: 'id',
			sortable: true
		},
		{
			header: t('InstalmentPayment_Transaction'),
			accessor: 'transaction',
			sortable: true
		},
		{
			header: t('InstalmentPayment_Amount'),
			accessor: 'amount',
			sortable: true,
			cell: amount => ui.formatAmount(amount)
		},
		{
			header: t('InstalmentPayment_Type'),
			accessor: 'type',
			cell: (type) => t(`InstalmentPaymentType_${type.name}`),
			sortable: true
		},
		{
			header: t('PaymentHistory_Status'),
			accessor: 'status',
			sortable: true,
			cell: (status, row) => {
				const label = <Label bsStyle={mapStatusToLabel(status.id)}>{t(`InstalmentPaymentStatusType_${status.name}`)}</Label>;
				const nextRetry = row.nextRetryDate ? t('InstalmentPayment_NextRetry', { nextRetryDate: ui.formatDateTime(row.nextRetryDate) }) : '';
				return status.id === 3 ? <LabelWithTooltip tooltip={`${row.cancellationReason} ${nextRetry}`}>{label}</LabelWithTooltip> : label;
			}
		},
		{
			header: t('InstalmentPayment_ChargeDate'),
			accessor: 'chargeDate',
			sortable: true,
			cell: chargeDate => ui.formatDate(chargeDate)
		},
		{
			header: t('PaymentHistory_PaymentDate'),
			accessor: 'paymentDate',
			sortable: true,
			cell: paymentDate => ui.formatDateTime(paymentDate)
		},
		{
			header: t('PaymentHistory_Created'),
			accessor: 'created',
			sortable: true,
			cell: created => ui.formatDateTime(created)
		}
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);